<template>
  <div class="rtl">
    <m-form
      title="ایجاد فاکتور"
      :apiUrl="baseUrl"
      :isEditing.sync="isEditing"
      :canSubmit="true"
      :showList="false"
      :canDelete="false"
      :canEdit="false"
      :showNavigationBtns="false"
      :showSubmitAndClearBtn="false"
      @submit="submit(true)"
      @clearForm="clearForm"
      ref="form"
    >
      <template #default>
        <v-row>
          <!-- User phone number -->
          <v-col cols="12" md="6">
            <v-text-field
              label="* شماره موبایل کاربر"
              v-model="item.phone"
              class="rounded-lg"
            />
          </v-col>

          <!-- Select package -->
          <v-col cols="12" md="6">
            <v-select
              label="نوع پکیج"
              v-model="item.selectedPackage"
              :items="allPackages"
              item-text="title"
              item-value="name"
              class="rounded-lg"
            />
          </v-col>

          <!-- Final amount (read-only) -->
          <v-col cols="12" md="6">
            <money
              label="* مبلغ نهایی"
              v-model="item.amount"
              :disabled="true"
              class="rounded-lg"
            />
          </v-col>

          <!-- Company ID -->
          <v-col cols="12" md="6">
            <v-text-field
              label="* شناسه شرکت"
              v-model="item.company"
              type="number"
              class="rounded-lg"
            />
          </v-col>

          <!-- Optional discount -->
          <v-col cols="12" md="6">
            <money
              label="مقدار تخفیف (اختیاری)"
              v-model="item.discount_amount"
              class="rounded-lg"
            />
          </v-col>

          <!-- Package billing cycle -->
          <v-col cols="12" md="6">
            <v-select
              label="بازه پکیج"
              v-model="item.billing_cycle"
              :items="[
                { text: 'ماهانه', value: 'monthly' },
                { text: 'سالانه', value: 'yearly' }
              ]"
              class="rounded-lg"
            />
          </v-col>

          <!-- Payroll addon switch -->
          <v-col cols="12" md="6">
            <v-switch 
              label="افزونه حقوق و دستمزد"
              v-model="item.hasPayroll"
            />
          </v-col>

          <!-- Payroll cycle select -->
          <v-col cols="12" md="6" v-if="item.hasPayroll">
            <v-select
              label="بازه حقوق و دستمزد"
              v-model="item.payroll_cycle"
              :items="[
                { text: 'ماهانه', value: 'monthly' },
                { text: 'سالانه', value: 'yearly' }
              ]"
              class="rounded-lg"
            />
          </v-col>
        </v-row>
      </template>
    </m-form>
  </div>
</template>

<script>
import MFormMixin from "@/components/m-form/MForm.js";
import Money from "@/components/mcomponents/cleave/Money.vue";

export default {
  mixins: [MFormMixin],
  components: { Money },
  data() {
    return {
      baseUrl: "sobhanAdmin/factor/create/",
      appendSlash: false,
      isEditing: true,
      item: {
        phone: "",
        amount: 0,
        company: null,
        discount_amount: 0,
        billing_cycle: null,
        payroll_cycle: null,
        selectedPackage: null,
        hasPayroll: false,
      },
      allPackages: [
        { name: "TWO", title: "پایه", price: 2400000 },
        { name: "THREE", title: "هوشمند", price: 4750000 },
        { name: "FOUR", title: "قدرتمند", price: 9750000 },
      ],
      payrollAddonMonthlyPrice: 2200000,
    };
  },
  watch: {
    'item.selectedPackage': 'calculatePrice',
    'item.billing_cycle': 'calculatePrice',
    'item.hasPayroll': 'calculatePrice',
    'item.payroll_cycle': 'calculatePrice',
  },
  methods: {
    // Reset form to initial state
    clearForm() {
      this.item = {
        phone: "",
        amount: 0,
        company: null,
        discount_amount: 0,
        billing_cycle: null,
        payroll_cycle: null,
        selectedPackage: null,
        hasPayroll: false,
      };
    },

    // Calculate total amount based on selected options
    calculatePrice() {
      const selectedPackage = this.allPackages.find(pkg => pkg.name === this.item.selectedPackage);
      let baseAmount = 0;

      // Base package calculation
      if (selectedPackage) {
        baseAmount = selectedPackage.price;
        if (this.item.billing_cycle === 'yearly') {
          baseAmount *= 12 * 0.8; // 20% discount for yearly plan
        }
      }

      // Payroll addon calculation
      if (this.item.hasPayroll && this.item.payroll_cycle) {
        let payrollPrice = this.payrollAddonMonthlyPrice;
        if (this.item.payroll_cycle === 'yearly') {
          payrollPrice *= 12 * 0.80; // 20% discount for yearly plan
        }
        baseAmount += payrollPrice;
      }

      // Final rounded amount
      this.item.amount = Math.floor(baseAmount);
    },

    // Serialize form data for API submission
    getSerialized() {
      const billingCycle = this.item.billing_cycle || this.item.payroll_cycle;
      const selectedPackage = this.allPackages.find(pkg => pkg.name === this.item.selectedPackage);
      const items = [];

      // Add base package item
      if (selectedPackage) {
        items.push({
          extension: selectedPackage.name,
          amount: billingCycle === 'yearly'
            ? selectedPackage.price * 12 * 0.8
            : selectedPackage.price,
          explanation: selectedPackage.title,
        });
      }

      // Add payroll item
      if (this.item.hasPayroll && this.item.payroll_cycle) {
        const isYearly = this.item.payroll_cycle === 'yearly';
        const payrollAmount = isYearly
          ? this.payrollAddonMonthlyPrice * 12 * 0.8
          : this.payrollAddonMonthlyPrice;

        items.push({
          extension: "PAYROLL",
          amount: payrollAmount,
          explanation: isYearly ? 'حقوق و دستمزد سالانه' : 'حقوق و دستمزد ماهانه',
        });
      }

      return {
        phone: this.item.phone,
        billing_cycle: billingCycle,
        amount: this.item.amount,
        company: this.item.company,
        discount_amount: this.item.discount_amount,
        items,
        explanation: this.item.explanation,
      };
    },
  }
};
</script>
